import * as React from "react";
import * as main from "../../main.module.scss";
import * as neuro from "./style.module.scss";
export const Neuro = ({ widgetFree, widgetPrice }) => {
  return (
    <section className={neuro.neuro}>
      <div className="container">
        <div className={neuro.container}>
          <div className={neuro.info}>
            <p className={neuro.sub}>Запишитесь на марафон и&nbsp;получите</p>
            <h2 className={main.title}>20 нейро-упражнений для&nbsp;развития мозга</h2>
            <p className={neuro.desc}>Упражнения из пальчиковой гимнастики для&nbsp;развития обоих полушарий мозга</p>
            <div className={neuro.form}>
              <h3>Заполните поля чтобы получить доступ:</h3>
              { widgetFree }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
